import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af244c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overflow-y-auto" }
const _hoisted_2 = { class: "py-8 md:py-16 text-center" }
const _hoisted_3 = { class: "text-gray-400 text-base" }
const _hoisted_4 = { class: "block mt-10 text-2xl font-semibold px-5" }
const _hoisted_5 = { class: "mt-10 text-xs" }
const _hoisted_6 = {
  class: "mt-5 grid xs:grid-cols-1 md:grid-cols-3 gap-5 mx-auto",
  style: {"width":"fit-content"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_input = _resolveComponent("base-image-input")!
  const _component_info_button = _resolveComponent("info-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("Pozdravljeni!")), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("Slikajte in naložite sliko vaše lokacije")), 1),
      _createVNode(_component_base_image_input, {
        modelValue: _ctx.imageFile,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.imageFile) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_info_button, {
        style: {"width":"fit-content","margin":"auto"},
        title: _ctx.$t('Navodila za slikanje')
      }, null, 8, ["title"]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("ali")), 1),
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("Izberite eno izmed predlog")), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "rounded-lg overflow-hidden md:h-32 cursor-pointer ring-primary hover:ring card-width",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectPreset(0)))
        }, [
          _createElementVNode("img", {
            src: _ctx.preview1,
            class: "object-cover w-full h-full"
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", {
          class: "rounded-lg overflow-hidden md:h-32 cursor-pointer ring-primary hover:ring card-width",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectPreset(1)))
        }, [
          _createElementVNode("img", {
            src: _ctx.preview2,
            class: "object-cover w-full h-full"
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("div", {
          class: "rounded-lg overflow-hidden md:h-32 cursor-pointer ring-primary hover:ring card-width",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectPreset(2)))
        }, [
          _createElementVNode("img", {
            src: _ctx.preview3,
            class: "object-cover w-full h-full"
          }, null, 8, _hoisted_9)
        ])
      ])
    ])
  ]))
}